import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../components/Card';
import { updateTenant } from '../../api/tenants';
import './ClosingPeriodCard.css';

/* Finance › Paramètres › Clôture — dernier mois réel clôturé.

   Déplacé de la barre supérieure le 2026-08-11 : le champ y était modifiable par
   des rôles que le serveur refuse (RH voyait un sélecteur qui renvoyait 403).
   Le bandeau garde l'INFORMATION, l'édition vit ici, avec les autres réglages
   financiers — donc réservée aux rôles habilités sur « Paramètres ».

   Deux listes plutôt qu'un <input type="month"> : Safari ne gère pas ce type et
   le rend en champ texte inerte. */

export default function ClosingPeriodCard({ activeTenant, onTenantPatched, addToast }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const months = useMemo(
    () => Array.from({ length: 12 }, (_, i) => t(`common:months.${i + 1}`)),
    [t],
  );

  const closed = activeTenant?.last_closed_period || null;
  const thisYear = new Date().getFullYear();
  const year = closed ? Number(closed.slice(0, 4)) : thisYear;
  const month = closed ? Number(closed.slice(5, 7)) : 12;
  const years = Array.from({ length: 9 }, (_, i) => thisYear - 6 + i);

  async function save(nextYear, nextMonth) {
    if (!activeTenant?.id) return;
    setBusy(true);
    const value = `${nextYear}-${String(nextMonth).padStart(2, '0')}-01`;
    const res = await updateTenant(activeTenant.id, { last_closed_period: value });
    setBusy(false);
    if (res.error || !res.data) {
      addToast?.(res.error || t('finance:settings.closing.saveFailed'), 'error');
      return;
    }
    onTenantPatched?.(res.data);
    addToast?.(t('finance:settings.closing.saved'));
  }

  return (
    <Card
      title={t('finance:settings.closing.title')}
      subtitle={t('finance:settings.closing.subtitle')}
    >
      <div className="closing-row">
        <label className="closing-field">
          <span className="closing-field__lbl">{t('finance:settings.closing.month')}</span>
          <select
            value={month}
            disabled={busy}
            onChange={(e) => save(year, Number(e.target.value))}
          >
            {months.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
        </label>
        <label className="closing-field">
          <span className="closing-field__lbl">{t('finance:settings.closing.year')}</span>
          <select
            value={year}
            disabled={busy}
            onChange={(e) => save(Number(e.target.value), month)}
          >
            {years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </label>
      </div>
      {!closed && (
        <p className="closing-empty">{t('finance:settings.closing.undefined')}</p>
      )}
    </Card>
  );
}
